﻿export default (baseClass) => {
  function addTab() {
    let parent = $(this);
    let tabBtns = $(baseClass + '__tab', parent);
    let tabBodies = $(baseClass + '__body', parent);
    let tabAccBodies = $(baseClass + '__accordion-body', parent);
    let oClass = 'is-open';

    function toggleTab(e) {
      e.preventDefault();
      let self = $(this);
      let target = $(self.attr('href'));

      let targetAccord = null;
      for (let i = 0; i < this.childNodes.length; i++) {
        if (this.childNodes[i].className === baseClass.substring(1) + '__accordion-body') {
          targetAccord = $(this.childNodes[i]);
          break;
        }
      }

      tabBtns.not(self).removeClass(oClass);
      tabBtns.not(self).attr('aria-expanded', 'false');
      self.addClass(oClass);
      self.attr('aria-expanded', 'true');

      tabBodies
      .not(target)
      .removeClass(oClass)
      .hide();
      target.addClass(oClass).fadeIn();
      
      if (screen.width < 480) {
        targetAccord.addClass(oClass).fadeIn();
      }
      tabAccBodies
      .not(targetAccord)
      .removeClass(oClass)
      .hide();
    }

    tabBodies.not('.' + oClass).fadeOut();
    tabAccBodies.not('.' + oClass).fadeOut();
    tabBtns.on('click', toggleTab);
  }

  $(baseClass).each(addTab);
};
